export default __webpack_public_path__ + "static/media/consultoria-aduaneira.5be45541.jpg";